import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=2dc036d6"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=2dc036d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports